/*eslint-disable*/ export const messages = JSON.parse(
    '{"ads.title.mlt":"Mer som dette","ads.title.personal":"Anbefalinger til deg","ads.title.popular":"Populære annonser"}',
);
